<section class="{{ class }}">
  <div class="text-center">
    <div class="justify-content-between mb-2">
      <h4>Zugang Angebotskonfigurator</h4>
    </div>
    <div class="justify-content-between mb-3 text-dark-grey">
      <p>
        Bitte gebe den 6-stelligen Sicherheitscode ein um
        <br />
        auf den Konfigurator zugreifen zu können.
      </p>
    </div>
    <div class="flex justify-between self-stretch text-black {{ class + '__security-code-text' }}">
      <p>Sicherheitscode</p>
    </div>
    <div class="flex justify-content-center">
      <p-inputOtp [(ngModel)]="accessCode" [length]="6" size="large" />
    </div>
    <div class="flex justify-content-center mt-5">
      <p-button
        (click)="verifyAccess()"
        label="Show"
        [label]="'Bestätigen'"
        [icon]="'pi pi-arrow-right'"
        iconPos="right"
        [class]="'p-text-normal'"
        [loading]="isVerifying"
        [disabled]="false"
      />
    </div>
    <div class="flex justify-content-center mt-2 {{ class + '__invalid-code' }}">
      <span class="small-text text-primary-color" *ngIf="invalidCode">
        {{ 'Ungültiger Code' }}
      </span>
    </div>
  </div>
</section>
